import { render, staticRenderFns } from "./UluroSolutions.vue?vue&type=template&id=e10ef35c&scoped=true&"
import script from "./UluroSolutions.vue?vue&type=script&lang=js&"
export * from "./UluroSolutions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e10ef35c",
  null
  
)

export default component.exports